// Generated by ts-to-zod
import {z} from "zod";

export const mantineDonutChartPropsSchema = z.object({
	h: z.number().optional(),
});
